// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"9876baad","668":"1473e437"}[chunkId] + ".chunk.css";
};